
  import ProviderDialog from '~/components/external-integrations/ProviderDialog.vue'

  export default {
    name: `ProviderDetailed`,
    components: { ProviderDialog },
    props: {
      selectedProvider: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        providerName: this.selectedProvider.name,
        providerIcon: this.selectedProvider.icon,
        providerDescription: this.selectedProvider.description,
        providerWhyTitle: this.selectedProvider.why_title,
        providerUseAeqApi: this.selectedProvider.use_aeq_api,
        cards: this.selectedProvider.cards || []
      }
    },
    methods: {
      goBack() {
        this.$store.commit(`integrations/setSelectedProvider`, undefined)
      }
    }
  }
